// extracted by mini-css-extract-plugin
export var messageSideLeft = "_le-1";
export var messageSideRight = "_le-2";
export var subscribeToBackInStockBubbleContainer = "_le-0";